import {humanNumber} from '../utils';
import {crToPb} from './cr-to-pb';
import {getCr} from './get-cr';

export function CrToXp(cr?: string | null, xpLair?: number | null, proficiencyNote?: string | null) {
	const crs: {[key: string]: number} = {
		'0': 0,
		'½': 100,
		'1/2': 100,
		'¼': 50,
		'1/4': 50,
		'⅛': 25,
		'1/8': 25,
		'1': 200,
		'2': 450,
		'3': 700,
		'4': 1100,
		'5': 1800,
		'6': 2300,
		'7': 2900,
		'8': 3900,
		'9': 5000,
		'10': 5900,
		'11': 7200,
		'12': 8400,
		'13': 10000,
		'14': 11500,
		'15': 13000,
		'16': 15000,
		'17': 18000,
		'18': 20000,
		'19': 22000,
		'20': 25000,
		'21': 33000,
		'22': 41000,
		'23': 50000,
		'24': 62000,
		'25': 75000,
		'26': 90000,
		'27': 105000,
		'28': 120000,
		'29': 135000,
		'30': 155000,
	};

	let result = '';
	let brackets = [];

	result = getCr(cr);

	let XpResult = humanNumber((cr && crs[cr]) || 0) + ' ПО';
	if (xpLair) XpResult += ` или ${humanNumber(xpLair)} ПО в логове`;
	brackets.push(XpResult);

	const proficiency = cr && crToPb(cr);
	let Pb = '';
	if (proficiencyNote) {
		Pb += 'БУ ' + proficiencyNote;
	} else if (proficiency) {
		Pb += `БУ +${proficiency}`;
	}

	if (Pb) brackets.push(Pb);

	if (brackets.length) result += ` (${brackets.join('; ')})`;

	return result;
}
